module.exports = __webpack_public_path__ + "static/media/location-arrow.35a2facb.svg";